import { EnvironmentInterface } from '../app/core/models/environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  apiUrl: '',
  apiMulesoftSuffix: '/api/v1',
  appUrl:  '',
  appApiUrl: '',
  providers: []
};
